<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">Group Introduction</div>
      <div class="contentTitle">公司简介</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="jtjj_item">
        <div class="itemText">
          <div class="itemTitle">关于我们</div>
          <div class="itemDetails">
            <p>
              深圳市云久鸿劳务派遣有限公司于2010年5月在深圳市龙华区成立，总部位于深圳市龙华区福城街道新和社区观澜大道111号101富嘉商务中心，是一家专业的人力资源平台。
            </p>
            <p>
              云久鸿始终秉持着诚信、责任、共赢、感恩的企业价值观，以用心服务，筑就行业新高度为使命，为打造值得全球信赖的就业服务平台而不懈努力。
            </p>
            <p>
              迄今为止，公司已服务企业客户达500多家，为富士康、比亚迪、伯恩光学、天马微等多家500强名企输送数以万计的人力资源。现可日均输送人力达2000多人次，全年输送人力10余万人次。
            </p>
            <p>
              经过10余年的发展，现已成为人力资源行业的领先企业，被深圳龙华区人民政府评定为服务业百强企业。
            </p>
            <p>
              现设云久鸿劳务派遣有限公司、云久鸿人力资源有限公司、景上鸿劳务派遣有限公司、云富鸿人力资源有限公司、蓝聘人力资源有限公司等多家子公司，并在深圳各个区设立了多家线下门店。
            </p>
          </div>
        </div>
        <div class="itemImg">
         <img :src="src.jtjj" class="img" alt srcset />
          <div class="bgBox">
          <img :src="src.border" alt srcset />
          </div>
        </div>
      </div>
    </div>
    <div class="mobile_contentBox">
      <div class="contentStitle">Group Introduction</div>
      <div class="contentTitle">公司简介</div>
      <div class="mobole_img">
        <img :src="src.jtjj" class="img" alt srcset />
        <div class="bgBox">
          <img :src="src.border" alt srcset />
        </div>
      </div>
      <div class="itemText">
        <div class="itemTitle">关于我们</div>
        <div class="itemDetails">
          <p>
            深圳市云久鸿劳务派遣有限公司于2010年5月在深圳市龙华区成立，总部位于深圳市龙华区福城街道新和社区观澜大道111号101富嘉商务中心，是一家专业的人力资源平台。
          </p>
          <p>
            云久鸿始终秉持着
            <span class="red">诚信、责任、共赢、感恩</span>
            的企业价值观，以
            <span class="red">用心服务，筑就行业新高度</span>
            为使命，为
            <span class="red">打造值得全球信赖的就业服务平台</span>
            而不懈努力。
          </p>
          <p>
            迄今为止，公司已服务企业客户达500多家，为富士康、比亚迪、伯恩光学、天马微等多家500强名企输送数以万计的人力资源。现可日均输送人力达2000多人次，全年输送人力10余万人次。
          </p>
          <p>
            经过10余年的发展，现已成为人力资源行业的领先企业，被深圳龙华区人民政府评定为服务业百强企业。
          </p>
          <p>
            现设云久鸿劳务派遣有限公司、云久鸿人力资源有限公司、景上鸿劳务派遣有限公司、云富鸿人力资源有限公司、蓝聘人力资源有限公司等多家子公司，并在深圳各个区设立了多家线下门店。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      src: src,
    };
  },
};
</script>

<style lang="less">
@media screen and (max-width: 999px) {
  .contentBox {
    display: none;
  }
  .mobile_contentBox {
    .mobole_img {
      // width: 60%;
      position: relative;
      padding-top: 25px;
      .img {
        height: 125px;
      }
      .bgBox {
        position: absolute;
        width: 190px;
        top: 0;
        right: 40px;
        img {
          width: 100%;
        }
      }
    }
    .itemText {
      text-align: left;
      margin-top: 50px;
      padding: 0 20px 20px;
      .itemTitle {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 700;
        color: #333333;
        line-height: 40px;
      }
      .itemDetails {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 27px;
      }
    }
  }
}
@media screen and (min-width: 1000px) {
  .mobile_contentBox {
    display: none;
  }
  .contentBox {
    .jtjj_item {
      margin-top: 50px;
      margin-bottom: 100px;
      display: flex;
      .itemText {
        width: 38%;
        text-align: left;
        margin-top: 50px;
        .itemTitle {
          font-size: 26px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 60px;
        }
        .itemDetails {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 27px;
        }
      }
      .itemImg {
        width: 60%;
        position: relative;
        padding-top: 120px;
        .img {
          height: 325px;
        }
        .bgBox {
          position: absolute;
          width: 500px;
          top: 50px;
          right: 0;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
